import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchClientSpocListResponse>}
 */

export function requestWorkstationBookingList(params) {
  return fetch.get(`${BASE_URL}/api/app/workstation-booking/`, {
    params: { limit: Number.MAX_SAFE_INTEGER },
  });
}

export function requestAddWorkstationBookingDetails(value) {
  const data = { ...value };
  delete data["_id"];
  return fetch.post(
    `${BASE_URL}/api/app/workstation-booking/add-booking-details`,
    data
  );  
}
